import {LitElement, html, CSSResult, unsafeCSS} from 'lit';
import {customElement, property} from "lit/decorators.js";
import styles from './reservation-badges.scss';
import {Messages} from "../../../@types/online-reservation.js";
import {consume} from "@lit/context";
import {i18nContext} from "../i18nContext.js";

@customElement('reservation-badges')
export class ReservationBadges extends LitElement {

  @property({type: String, reflect: false})
  private readonly sizeDescription: string = '';

  @property({type: String, reflect: false})
  private readonly storeLocationName: string = '';

  @property({ type: Boolean })
  private showSizeBadge = true;

  @consume({context: i18nContext})
  private readonly messages!: Messages;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  render() {
    return html`
      <div class="ents-reservation-badges">
        ${this.showSizeBadge ? html`
          <div class="bdk-badge-system ents-copy-extra-small" variant="neutral" data-test-ents-or-size-badge>
            ${this.messages.size}
            <span class="ents-copy-extra-small-bold">${this.sizeDescription}</span>
          </div>
        ` : ''}
        ${this.storeLocationName ? html`
          <div class="bdk-badge-system ents-copy-extra-small" variant="neutral" data-test-ents-or-store-badge>
            ${this.messages.store}
            <span class="ents-copy-extra-small-bold">${this.storeLocationName}</span>
          </div>
        ` : ''}
      </div>
    `;
  }
}
